import Swiper from "swiper"
import { Navigation, Pagination, EffectFade, Autoplay } from "swiper/modules"

export default (props) => ({
  artists: props.artists || [],
  selectedArtistIndex: 0,
  isOpen: false,
  swiperInstance: null,
  activeSlideIndex: 0,
  artistsByHandle: {},
  loadedArtists: new Set(),

  get selectedArtist() {
    return this.artists[this.selectedArtistIndex]
  },

  get activeProduct() {
    if (!this.selectedArtist?.products?.length) {
      return { title: "" }
    }
    return this.selectedArtist.products[this.activeSlideIndex] || { title: "" }
  },

  async getArtistCollections(handle) {
    if (this.loadedArtists.has(handle)) return

    try {
      const res = await fetch(`/collections/${handle}?view=json-first-4`, {
        priority: "low",
      })
      const data = await res.json()

      const artist = this.artistsByHandle[handle]
      if (artist) {
        artist.products = data.products
        artist.url = `/collections/${handle}`
        this.loadedArtists.add(handle)
      }
    } catch (error) {
      console.error("Error fetching artist collections:", error)
    }
  },

  async fetchAllArtists() {
    const promises = this.artists.map((artist) =>
      this.getArtistCollections(artist.handle)
    )

    await Promise.allSettled(promises)
  },

  init() {
    this.artists.forEach((artist) => {
      if (artist.handle) {
        this.artistsByHandle[artist.handle] = artist
      }
    })

    this.$watch("$store.globalState.mainMenuIsOpen", (isOpen) => {
      if (isOpen && this.loadedArtists.size === 0) {
        this.fetchAllArtists()
      }
    })
  },

  closeArtistMenu() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true)
      this.swiperInstance = null
    }
    this.isOpen = false
    this.selectedArtistIndex = 0
    this.activeSlideIndex = 0
  },

  selectArtist(index) {
    if (this.selectedArtistIndex === index && this.isOpen) {
      this.closeArtistMenu()
      return
    }

    this.closeArtistMenu()
    this.selectedArtistIndex = index
    this.activeSlideIndex = 0
    this.isOpen = true

    this.$nextTick(() => {
      const swiperEl = this.$refs.swiper

      if (swiperEl) {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true)
          this.swiperInstance = null
        }

        // Wait for content to be rendered
        requestAnimationFrame(() => {
          const self = this
          this.swiperInstance = new Swiper(swiperEl, {
            modules: [Navigation, Pagination, EffectFade, Autoplay],
            slidesPerView: 1,
            effect: "fade",
            speed: 100,
            fadeEffect: {
              crossFade: false,
            },
            loop: true,
            autoplay: { delay: 800 },
            pagination: {
              el: "[data-artists-carousel-pagination]",
              type: "bullets",
            },
            observer: true,
            observeParents: true,
            watchOverflow: true,
            resizeObserver: true,
            updateOnWindowResize: true,
            preloadImages: false,
            lazy: true,
            on: {
              slideChange: function () {
                self.activeSlideIndex = this.realIndex
              },
              init: function () {
                this.update()
              },
            },
          })
        })
      }
    })
  },
})
